import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NavigationItem = ({ icon: Icon, href, onClick, text }) => (
  <Link
    className="text-blue-700 items-center flex mr-2 text-sm font-semibold"
    onClick={onClick}
    to={href}
  >
    <Icon className="mr-1 w-2 h-2 fill-current" />
    {text}
  </Link>
);

NavigationItem.propTypes = {
  href: propTypes.string.isRequired,
  icon: propTypes.func.isRequired,
  onClick: propTypes.func,
  text: propTypes.string.isRequired,
};

NavigationItem.defaultProps = {
  onClick: () => null,
};

export default NavigationItem;
export { NavigationItem };
